import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { provideStore } from '@ngrx/store';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { HttpRequestService } from './shared/services/http-request/http-request.service';
import { InitCallReducer } from './shared/state/call/call.reducer';
import { NgbDateCustomParserFormatter } from './shared/utilities/datefomatter';
import { SocketHttpRequestService } from './shared/services/http-request/socket-http-request.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideServiceWorker('firebase-messaging-sw.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([TokenInterceptor])),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: false,
          cssLayer: false,
        },
      },
    }),
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    provideStore({ call: InitCallReducer }),
    HttpRequestService,
    SocketHttpRequestService
  ],
};
